import { Injectable } from '@angular/core';

type EventCallback = (data?: any) => void;

@Injectable({
  providedIn: 'root'
})
export class EventBusService {
  private events: { [event: string]: EventCallback[] } = {};

  subscribe(event: string, callback: EventCallback): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  unsubscribe(event: string, callback: EventCallback): void {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(cb => cb !== callback);
  }

  publish(event: string, data?: any): void {
    if (!this.events[event]) return;
    this.events[event].forEach(callback => callback(data));
  }
}

export type { EventCallback };
